const bannerTypes = {
    TIER: 'Tier',
    PPV: 'PPV',
    OTHERS: 'Others',
    ROTATING_CONTENT: 'RotatingContent'
};

export {bannerTypes};
